import React from "react";
import { FaHeart } from "react-icons/fa";

const AccessDenied = () => {
  return (
    <div
      className="d-flex flex-column justify-content-center align-items-center text-center"
      style={{
        minHeight: "100vh",
        background: "#f8f9fa",
        padding: "20px",
      }}
    >
      <div
        className="shadow-sm p-5 bg-white rounded-4"
        style={{ maxWidth: "600px", width: "100%" }}
      >
        <FaHeart size={70} color="#E5484D" />

        <h1 className="mt-4 fw-bold" style={{ color: "#E5484D" }}>
          Thank You!
        </h1>

        <h3 className="mb-3">Thank You for Visiting SheRent Admin Panel</h3>

        <p className="text-muted fs-5">
          We appreciate your visit to the SheRent Admin Portal.
          Your support helps us create a better experience for users
          searching for flats and flatmates.
        </p>

        <p className="text-muted">
          Have a great day and thank you for being part of the SheRent journey.
        </p>
      </div>
    </div>
  );
};

export default AccessDenied;